import { IIconProps } from "../types"

export default function IconLR1(props: IIconProps) {
  const width = props.size || props.width || (86 / 5) * 3
  const height = props.size || props.height || (115 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 86 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6217 1.77185C32.0284 0.942119 49.3528 0.50226 59.8695 0.452276C70.3861 0.412289 74.1049 0.762177 76.6841 1.64189C79.2732 2.52161 80.7328 3.93116 81.9224 5.60063C83.102 7.27009 84.0017 9.19947 84.4516 12.6284C84.9014 16.0573 84.9014 20.9757 84.6215 29.503C84.3416 38.0202 83.7718 50.1463 81.8024 63.2821C79.8331 76.4179 76.4641 90.5634 73.875 98.8707C71.2858 107.178 69.4864 109.637 65.7776 111.347C62.0588 113.066 56.4406 114.036 50.4225 114.336C44.4044 114.646 37.9865 114.296 33.098 113.366C28.1996 112.446 24.8307 110.957 22.3515 109.237C19.8723 107.528 18.3028 105.599 14.9838 95.8417C11.6649 86.0848 6.60654 68.5105 3.95739 56.6942C1.31823 44.878 1.08831 38.81 0.808395 32.1321C0.528485 25.4543 0.188594 18.1666 0.758411 13.5481C1.31823 8.93955 2.77776 7.00018 5.25697 5.42068C7.72618 3.84119 11.2151 2.61158 21.6217 1.77185Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
